// extracted by mini-css-extract-plugin
export var boxItems = "_91-1";
export var boxItemsLg = "_91-2";
export var button = "_91-7";
export var buttonHoverless = "_91-9";
export var buttonLg = "_91-8";
export var filterGroupBox = "_91-0";
export var icon = "_91-3";
export var iconSecondary = "_91-6";
export var iconWrapper = "_91-4";
export var iconWrapperLg = "_91-5";
export var truncatedLabel = "_91-a";